import { baseApi } from './baseApi';
import type { ApiResponse, Transaction } from '../../types/api';

interface TransactionsQueryParams {
  page?: number;
  limit?: number;
  userId?: number;
  type?: 'recharge' | 'debit' | 'referral' | 'refund' | 'admin_add' | 'admin_deduct';
  status?: 'pending' | 'completed' | 'failed' | 'reversed';
  method?: 'Syriatel' | 'Sham' | 'Payeer' | 'Cryptomus';
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

interface TransactionsResponse {
  transactions: Transaction[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const transactionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.query<ApiResponse<TransactionsResponse>, TransactionsQueryParams>({
      query: (params) => ({
        url: '/transactions',
        method: 'GET',
        params,
      }),
      providesTags: ['Transaction'],
    }),
    getTransactionById: builder.query<ApiResponse<{ transaction: Transaction }>, string>({
      query: (id) => ({
        url: `/transactions/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Transaction', id }],
    }),
  }),
});

export const { useGetTransactionsQuery, useGetTransactionByIdQuery } = transactionsApi;
